"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";

// Jin routes par widget HIDE karna hai, unko yahan add karein (exact match)
const HIDDEN_ROUTES = ["/recruitment-automation-software","/leap","/cancel-meeting","/reschedule"];

export default function ConditionalWidget() {
  const pathname = usePathname();

  const shouldHide = HIDDEN_ROUTES.includes(pathname);

  if (shouldHide) return null;

  return (
    <Script src="https://www.goku.getgeek.ai/widget.js" strategy="lazyOnload" />
  );
}
